import { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import cyberBay from "../../assets/img/CyberBayWhite.png";

export const DesktopSidebar = ({
  items,
  currentPath,
  setActiveTab,
  screenWidth,
  isCollapsed,
  isOverlay
}) => {
  const [openAccordion, setOpenAccordion] = useState(null);

useEffect(() => {
  const activeIndex = items.findIndex(item =>
    item.subItems?.some(sub =>
      currentPath === `/${sub.path}` || currentPath.startsWith(`/${sub.path}/`)
    )
  );
  if (activeIndex !== -1) setOpenAccordion(activeIndex);
}, [currentPath, items]);


const handleItemClick = (item, index) => {
  if (item.subItems?.length) {
    if (item.path) {
      setActiveTab(item.path);   
    }
    setOpenAccordion(openAccordion === index ? null : index);
  } else {
    setActiveTab(item.path);
  }
};

  return (
    <div
      className={`shadow d-flex flex-column`}
      style={{
        position: 'fixed',
        left: 0,
        width: "clamp(210px, 16vw, 282px)",
        height: "calc(100vh - 90px)",
        zIndex: 1000,
        transition: "width 0.4s ease",
        marginTop:  '28px',
      }}
    >
      <div className="scrollable-sidebar position-relative sidebar">
        <ul className="nav flex-column mt-4 sidebar-list">
          {items.map((item, index) => {
            const isActiveMain = currentPath === `/${item.path}`;
            const cleanedPath = currentPath.split("?")[0].replace(/\/$/, "");
            const hasActiveChild = item.subItems?.some(
              sub => cleanedPath.startsWith(`/${sub.path}`)
            );
            return (
              <li key={index} className="nav-item position-relative" style={{ cursor: "pointer" }}>
                <div
                  className={`nav-link d-flex align-items-center py-2 
  ${isActiveMain ? "active-sidebar" : hasActiveChild ? "highlight-sidebar" : ""}`}

                 style={{
  paddingLeft: "clamp(10px, 1vw, 16px)",
  paddingRight: "clamp(10px, 1vw, 16px)",
  backgroundColor: isActiveMain || hasActiveChild ? "#0D0D0D" : "transparent",
  marginTop: "10px",
  transition: "all 0.4s ease",
}}
                  onClick={() => handleItemClick(item, index)}
                >
                  <div className="active-border"></div>
                  <div>{item.icon}</div>
                  <div
                    className="d-flex align-items-center"
                    style={{
                      flex: 1,
                      minWidth: 0,  
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      transition: "max-width 0.3s ease, opacity 0.3s ease",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span className="sidebar-label ms-2">{item.name}</span>
                    {item.subItems && (
                      <span className="ms-auto" style={{ fontSize: "12px" }}>
                        {openAccordion === index ? <FaChevronUp /> : <FaChevronDown />}
                      </span>
                    )}
                  </div>
                </div>

                {/* SubItems */}
                {item.subItems && openAccordion === index && (
                  <ul className="nav flex-column mt-1">
                    {item.subItems.map((sub, subIndex) => {
                      const isActiveSub =
                        cleanedPath === `/${sub.path}` || cleanedPath.startsWith(`/${sub.path}/`);
                      return (
                        <li
                          key={subIndex}
                          className="nav-item"
                          style={{ cursor: "pointer", marginTop: "5px" }}
                          onClick={() => setActiveTab(sub.path)}
                        >
                          <div
                            className={`nav-link d-flex align-items-center ${isActiveSub ? "active-sidebar" : ""}`}
                            style={{
                              color: "#ccc",
                              width: "100%",
                              backgroundColor: isActiveSub ? "#0D0D0D" : "transparent",
                            }}
                          >

                            <div className='ps-3' style={{ minWidth: "21px" }} >{sub.icon}</div>
                            <span className="sub-items ps-2" >{sub.name}</span>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
        {/* Footer Version */}
 <div className="text-center  mt-auto py-3">
    
    <div className="text-white fw-normal">v 2.2.0</div>
  </div>  
      </div>
    </div>
  );
};

export const MobileSidebar = ({ setSidebarOpen, items, currentPath, setActiveTab }) => {
  const [openAccordion, setOpenAccordion] = useState(null);

 useEffect(() => {
  const activeIndex = items.findIndex(item =>
    item.subItems?.some(sub =>
      currentPath === `/${sub.path}` || currentPath.startsWith(`/${sub.path}/`)
    )
  );
  if (activeIndex !== -1) setOpenAccordion(activeIndex);
}, [currentPath, items]);

const handleItemClick = (item, index) => {
  if (item.subItems?.length) {
    if (item.path) {
      setActiveTab(item.path);  
      setSidebarOpen(true);
    }
    setOpenAccordion(openAccordion === index ? null : index);
  } else {
    setActiveTab(item.path);
    setSidebarOpen(true);
  }
};

  return (
    <>
      <div className="position-fixed top-0 start-0 vh-100 shadow sidebar" style={{ width: "260px", zIndex: 1200 }}>
        <div className="d-flex justify-content-between align-items-center p-3">
          <img src={cyberBay} alt="Logo" style={{ maxWidth: "60px", height: "auto" }} />
          <button className="btn btn-sm text-white fs-4 px-2 py-0 border" onClick={() => setSidebarOpen(false)}>X</button>
        </div>
        <div className="scrollable-sidebar">
        <ul className="nav flex-column mt-3">
          {items.map((item, index) => {
            const isActiveMain = currentPath === `/${item.path}`;
            const cleanedPath = currentPath.split("?")[0].replace(/\/$/, "");
            const hasActiveChild = item.subItems?.some(
              sub => cleanedPath.startsWith(`/${sub.path}`)
            );

            return (
              <li key={index} className="nav-item" style={{ cursor: "pointer" }}>
                <div
                  className={`nav-link d-flex align-items-center py-2 
              ${isActiveMain ? "active-sidebar" : hasActiveChild ? "highlight-sidebar" : ""}`}

                  onClick={() => handleItemClick(item, index)}
                >
                  <div className="d-flex align-items-center w-100">
                    <div style={{ minWidth: "24px" }}>{item.icon}</div>
                    <span className="sidebar-label ms-2">{item.name}</span>
                    {item.subItems && (
                      <span className="ms-auto" style={{ paddingRight: "10px", fontSize: "12px" }}>
                        {openAccordion === index ? <FaChevronUp /> : <FaChevronDown />}
                      </span>
                    )}
                  </div>
                </div>

                {/* SubItems */}
                {item.subItems && openAccordion === index && (
                  <ul className="nav flex-column">
                    {item.subItems.map((sub, subIndex) => {
                      const isActiveSub =
                        cleanedPath === `/${sub.path}` || cleanedPath.startsWith(`/${sub.path}/`);
                      return (
                        <li
                          key={subIndex}
                          className="nav-item"
                          style={{ cursor: "pointer", marginTop: "5px" }}
                          onClick={() => {
                            setActiveTab(sub.path);
                            setSidebarOpen(false);
                          }}
                        >
                          <div
                            className={`nav-link d-flex align-items-center ${isActiveSub ? "active-sidebar" : ""}`}
                            style={{ fontSize: "14px", color: "#ccc", paddingLeft: "10px" }}
                          >
                            <div className="ps-3" style={{ minWidth: "20px" }}>{sub.icon}</div>
                            <span className="sub-items ps-1">{sub.name}</span>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
<div className="text-center  mt-auto py-3">
    
    <div className="text-white fw-normal">v 2.2.0</div>
  </div>
      </div>
  </div> 

      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.8)", zIndex: 1150 }}
        onClick={() => setSidebarOpen(false)}
      />
      
    </>
  );
};